import router from "../../router";
import * as userStorage from "@/utils/auth";

const user = {
  state: {
    userInfo: localStorage.getItem("USER_INFO_STORAGE") ,
    token: localStorage.getItem("USER_TOKEN_STORAGE"),
    mobile: localStorage.getItem("MOBILENUM"),
    userName: ''
  },
  mutations: {
    SET_USER: (state, userInfo) => {
      state.userInfo = userInfo;
      userStorage.setUserInfo(userInfo);
    },
    RESET_USER: (state) => {
      state.userInfo = {};
      userStorage.removeUserInfo()
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
      userStorage.setToken(token)
    },
    RESET_TOKEN: (state) => {
      state.token = "";
      userStorage.removeToken()
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile;
      userStorage.setMobil(mobile)
    },
    RESET_MOBILE: (state) => {
      state.mobile = "";
      userStorage.removeMobil()
    },
    SET_USERNAME: (state, userName) => {
      state.userName = userName
    },
  },
  actions: {
    LoginAction({ commit, state }, data) {
      commit("SET_USER", data.userInfo);
      commit("SET_TOKEN", data.token)
      commit("SET_MOBILE", data.mobile)
    },

    LogoutAction({commit}) {
      commit("RESET_TOKEN")
      commit("RESET_USER")
      commit("RESET_MOBILE")
    },

    setUserName({ commit }, userName) {
      if(!userName) return
      commit('SET_USERNAME', userName)
    },

    // // 登录
    // Login({commit, state}, loginForm) {
    //   return new Promise((resolve, reject) => {
    //     api({
    //       url: "login/auth",
    //       method: "post",
    //       data: loginForm
    //     }).then(data => {
    //       if (data.result === "success") {
    //         //cookie中保存前端登录状态
    //         setToken();
    //       }
    //       resolve(data);
    //     }).catch(err => {
    //       reject(err)
    //     })
    //   })
    // },
    // // 获取用户信息
    // GetInfo({commit, state}) {
    //   return new Promise((resolve, reject) => {
    //     api({
    //       url: '/login/getInfo',
    //       method: 'post'
    //     }).then(data => {
    //       //储存用户信息
    //       commit('SET_USER', data.userPermission);
    //       //cookie保存登录状态,仅靠vuex保存的话,页面刷新就会丢失登录状态
    //       setToken();
    //       //生成路由
    //       let userPermission = data.userPermission ;
    //       store.dispatch('GenerateRoutes', userPermission).then(() => {
    //         //生成该用户的新路由json操作完毕之后,调用vue-router的动态新增路由方法,将新路由添加
    //         router.addRoutes(store.getters.addRouters)
    //       })
    //       resolve(data)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // // 登出
    // LogOut({commit}) {
    //   return new Promise((resolve) => {
    //     api({
    //       url: "login/logout",
    //       method: "post"
    //     }).then(data => {
    //       commit('RESET_USER')
    //       removeToken()
    //       resolve(data);
    //     }).catch(() => {
    //       commit('RESET_USER')
    //       removeToken()
    //     })
    //   })
    // },
    // // 前端 登出
    // FedLogOut({commit}) {
    //   return new Promise(resolve => {
    //     commit('RESET_USER')
    //     removeToken()
    //     resolve()
    //   })
    // }
  },
};
export default user;
